import React from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import { Clock, LayoutDashboard, Shield } from 'lucide-react';
import UserDashboard from './pages/UserDashboard';
import AdminDashboard from './pages/AdminDashboard';

function App() {
    return (
        <Router>
            <div className="flex flex-col min-h-screen p-8 w-full">
                <main className="flex-1">
                    <Routes>
                        <Route path="/" element={<UserDashboard />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                    </Routes>
                </main>
            </div>
        </Router>
    );
}

export default App;
